/**
 * 전화번호를 하이픈(`-`)이 들어간 형태로 변환합니다.
 * 서울 국번인 경우(`02XXXXZZZZ`)나 10자리 전화번호인 경우(`011XXXZZZZ`) 형태에도 대응합니다.
 * @example
 * ```ts
 * formatPhoneNumber('01025560000'); // '010-2556-0000'
 * formatPhoneNumber('0215994905'); // '02-1599-4905'
 * formatPhoneNumber('0110000000'); // '011-000-0000'
 * ```
 */
export function formatPhoneNumber(phoneNumber: string): string {
  // 서울 국번(02)인 경우에만 지역번호가 2자리입니다.
  const isSeoulNumber = phoneNumber.startsWith('02');

  // 12자리 전화번호는 앞자리가 4개입니다.
  const is12Number = phoneNumber.length === 12;

  const areaCodeEndIndex = isSeoulNumber ? 2 : is12Number ? 4 : 3;

  // 9 ~ 12자리 전화번호에 대응하기 위해서
  // [0:areaCodeEndIndex], [areaCodeEndIndex:length-4], [length-4:length] 형식으로 나누고 join합니다.
  return [
    phoneNumber.slice(0, areaCodeEndIndex),
    phoneNumber.slice(areaCodeEndIndex, phoneNumber.length - 4),
    phoneNumber.slice(phoneNumber.length - 4),
  ].join('-');
}
